import Simple from 'assets/images/farm/typesAd/simple.svg';
import Auction from 'assets/images/farm/typesAd/auction.svg';
import Sale from 'assets/images/farm/typesAd/sale.svg';
import Presale from 'assets/images/farm/typesAd/presale.svg';
const GuideComponent = ({app}: IGuideComponentProps) => {
  return (
    <div className=" px-3 pb-12">
      <img alt="simple" src={Simple} className="block mx-auto" />
      <p className=" text-gray-6">قیمت ثابت:</p>
      <p className=" text-gray-6 text-justify">
        در این نوع از آگهی، یک قیمت واحد برای محصول تعیین میشود و خریداران با
        توجه به توضیحات، قیمت، کیفیت و ... برای خرید با شما از طریق ارسال پیام
        یا تماس تلفنی ارتباط برقرار میکنند.
      </p>
      <img alt="simple" src={Auction} className="block mx-auto my-3" />
      <p className=" text-gray-6">حراجی:</p>

      <p className=" text-gray-6 text-justify">
        در ابتدا مبلغی برای "شروع قیمت" به معنی بیشترین قیمت ممکن در حراجی و
        مبلغی برای"حداقل قیمت" به معنی کمترین قیمت حراجی توسط فروشنده تعیین
        میشود. سپس مدت زمان حراجی و روند کاهش قیمت مشخص میشود و قیمت محصول پس از
        انتشار آگهی بصورت تدریجی از بیشترین به کمترین مبلغ کاهش مییابد. به طور
        مثال: اگر شروع قیمت 1 میلیون تومان و حداقل قیمت 600 هزار تومان باشد و
        مدت زمان حراجی 4 روز و روند کاهش قیمت 10 درصد در نظر گرفته شده باشد، از
        زمان انتشار آگهی تا پایان مهلت، قیمت محصول از 1 میلیون تومان در 10 مرحله
        هربار 40 هزارتومان کاهش پیدا میکند و در آخرین ساعات حراجی به 600 هزار
        تومان میرسد.
      </p>
      <img alt="simple" src={Sale} className="block mx-auto my-3" />
      <p className=" text-gray-6">مزایده:</p>

      <p className=" text-gray-6 text-justify">
        میتوانید قبل از برداشت محصول و یا بعد از برداشت محصول آگهی مزایده ثبت
        کنید. در این روش فروش مبلغی به عنوان "قیمت پایه" و مدت زمان مزایده تعیین
        میشود و خریداران قیمتهای پیشنهادی خود را برای فروشنده ارسال میکنند.
        قیمتهای پیشنهادی نمیتواند کمتر از قیمت پایه باشد. فهرست همه مبلغهای
        پیشنهادی در اختیار فروشنده قرار میگیرد و فروشنده میتواند از طریق ارسال
        پیام با پیشنهاد دهندگان ارتباط برقرار کند. در نهایت یک نفر به عنوان
        برنده مزایده از سمت فروشنده انتخاب میشود.
      </p>
      {app === 'farm' && (
        <>
          <img alt="simple" src={Presale} className="block mx-auto my-3" />
          <p className=" text-gray-6">سلف:</p>

          <p className=" text-gray-6 text-justify">
            اگر قصد کشت محصولی را دارید، میتوانید برای تامین بودجه مورد نیاز
            خرید بذر، کود، سم و ادوات کشاورزی، کشت خود را در سامانه مزرعه ثبت
            کنید و سپس در حجره کشت مورد نظر را انتخاب کرده و مقدار نیاز مالی خود
            را به صورت نقدی یا اعتباری تعیین کنید. با انتشار آگهی، خریدارن محصول
            پیشنهادات خود را ثبت می کنند و تعیین میکنند در ازای پرداخت مبلغ مورد
            نیاز کشاورز، چه مقدار محصول در زمان برداشت دریافت خواهند کرد. فهرست
            همه پیشنهادها برای کشاورزان ارسال میشود و کشاورز میتواند با پیشنهاد
            دهندگان برای تامین مالی مزرعه خود تماس بگیرد. در نهایت یک نفر به
            عنوان تامین کننده مالی از سمت کشاورز انتخاب میشود.
          </p>
        </>
      )}
    </div>
  );
};

export default GuideComponent;
